import { useEffect } from 'react';
import * as eva from 'eva-icons';

const Icon = ({ name, color, size }) => {
  useEffect(() => {
    eva.replace();
  }, []);

  return (
    <div className="d-flex align-items-center">
      <i
        data-eva={name}
        data-eva-fill={color}
        data-eva-height={size}
        data-eva-width={size}
      ></i>
    </div>
  );
};

Icon.defaultProps = {
  color: '#000000',
  size: 24,
};

export default Icon;
